var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidneyCardE3B(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 158,
    height: 158,
    rx: 12,
    fill: "#fff",
    stroke: "#DB0F00",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.533 107.075c-25.74-10.667-15.582-46.674 2.286-52.622 7.414-2.468 15.59 5.72 15.54 10.802-.024 2.197-1.177 4.341-2.381 6.574-1.578 2.933-3.241 6.018-2.535 9.587 1.244 6.285 2.637 16.892-.953 21.925-3.589 5.035-7.197 5.706-11.957 3.734zM107.18 54.453c17.868 5.948 28.027 41.955 2.286 52.622-4.76 1.974-8.368 1.301-11.957-3.734-3.59-5.033-2.197-15.64-.953-21.925.706-3.57-.957-6.656-2.535-9.587-1.204-2.233-2.357-4.377-2.379-6.574-.052-5.082 8.127-13.27 15.538-10.802zM93.606 88.514l.166 2.32h.029l.007-.002c-.135.02-.268.048-.398.084-.401.112-.78.29-1.121.526-.687.48-1.696 1.546-1.696 4.237V109a2 2 0 0 1-2 2h-.739a2 2 0 0 1-2-2V95.68c0-4.112 1.682-6.629 3.684-8.032a8.5 8.5 0 0 1 3.46-1.404 5.96 5.96 0 0 1 .378-.047l.038-.004h.026c0-.003.005-.003.166 2.32zM71.392 88.514c-.16 2.32-.163 2.32-.165 2.32h-.029l-.007-.002.057.007a3.714 3.714 0 0 1 1.462.601c.687.482 1.696 1.548 1.696 4.24V109a2 2 0 0 0 2 2h.739a2 2 0 0 0 2-2V95.68c0-4.112-1.682-6.629-3.687-8.032A8.497 8.497 0 0 0 72 86.244a5.96 5.96 0 0 0-.379-.047l-.035-.004h-.027c0-.003-.002-.003-.166 2.32z",
    fill: "#945959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyCardE3B);
export default __webpack_public_path__ + "static/media/kidneyCardE3b.2d8954a5.svg";
export { ForwardRef as ReactComponent };